import { render, staticRenderFns } from "./OfferTypeTag.vue?vue&type=template&id=689d6519&scoped=true&"
import script from "./OfferTypeTag.vue?vue&type=script&lang=ts&"
export * from "./OfferTypeTag.vue?vue&type=script&lang=ts&"
import style0 from "./OfferTypeTag.vue?vue&type=style&index=0&id=689d6519&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689d6519",
  null
  
)

export default component.exports